// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CertificatesPage_wrapper__1rgBb"};